export default __webpack_public_path__ + "static/media/hardwork.1e9e990c.png";